<style
  scoped
  lang="less">
  @active-blue: #56b4f8;

  div, span {
    margin: 0;
    padding: 0;
    word-wrap: break-word;
    font-family:"Noto Sans CJK SC", "Source Han Sans CN";
  }

  .city {
    width: 160px;
    border: 1px solid #bfcbd9;
    height: 30px;
    padding-left: 10px;
    background: url("//v3.cdn.qiyewan.com/tuichu.png") no-repeat 134px center;
    line-height: 30px;
  }

  .cityTabs {
    width: 450px;
    display: inline-block;
    border: 2px solid #eee;
    padding: 5px;
    position: absolute;
    z-index: 11;
    background-color: #fff;
    span {
      color: @active-blue;
      padding: 1px 3px;
      line-height: 15px;
      text-align: center;
      border-radius: 3px;
      position: absolute;
      right: 10px;
      top: 10px;
      border: 1px solid @active-blue;
      cursor: pointer;
    }
  }

  ._citys0 {
    width: 100%;
    height: 38px;
    display: inline-block;
    border-bottom: 2px solid @active-blue;
    padding: 0;
    margin: 0;
  }

  ul {
    list-style: none;
    font-style: normal;
    font-size: 100%;
  }

  ._citys0 li {
    display: inline-block;
    line-height: 34px;
    font-size: 15px;
    color: #888;
    width: 80px;
    text-align: center;
    cursor: pointer;
  }

  ._citys1 {
    width: 100%;
    display: inline-block;
    padding: 10px 0;
    a {
      width: 83px;
      height: 35px;
      display: inline-block;
      background-color: #f5f5f5;
      color: #666;
      margin-left: 6px;
      margin-top: 3px;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      font-size: 13px;
      overflow: hidden;
    }
  }

  .selected {
    background-color: @active-blue !important;
    color: #fff !important;
  }

  .active {
    background-color: @active-blue;
    color: #fff !important;
  }

  ._citys1 a:hover {
    background-color: @active-blue !important;
    color: #fff !important;
  }

  .hidden {
    display: none;
  }

</style>
<template>
  <div>
    <div class="city" @click="visible=!visible">{{regionInfo}}</div>
    <div class="cityTabs" :class="{hidden: !visible}">
      <span title="关闭" @click="closeTab">×</span>
      <ul class="_citys0">
        <li :class="{active: isCity}" @click="isCity = true">城市</li>
        <li :class="{active: !isCity}" @click="isCity = false">区县</li>
      </ul>
      <div :class="{hidden: !isCity}" class="_citys1">
        <a v-for='(item,index) in getRegions'
           :class="{selected: cityCode===item.code}"
           @click="changeCity(item)">{{item.name}}</a>
      </div>
      <div :class="{hidden: isCity}" class="_citys1">
        <a v-for='(item,index) in districts'
           :class="{selected: district===item}"
           @click="changeRegion(item)">{{item}}</a>
      </div>
    </div>
  </div>
</template>
<script>
  import dataApi from '../api/data'
  import {mapGetters} from "vuex"
  export default {
    data () {
      return {
        visible: false,
        isCity: true,
      }
    },
    props: {
      district: String,
    },
    computed: {
      ...mapGetters({
        getRegion: 'getRegion',
        getRegions: 'getRegions',
      }),
      districts(){
        return this.getRegion.areas
      },
      cityCode(){
        return this.getRegion.code
      },
      regionInfo() {
        return `${this.getRegion.name}-${this.district}`
      }
    },

    methods: {
      changeCity: function (city) {
        this.$emit('changeCity', city)
        this.isCity = false
      },
      changeRegion: function (district) {
        this.$emit('changeRegion', district)
        this.closeTab()
      },
      closeTab(){
        this.visible = false
      }
    },
    created () {
    },

  }
</script>



// WEBPACK FOOTER //
// AreaPicker.vue?21e4def1